export function assignProp<T>(to: T, from: T, key: keyof T): void {
  to[key] = from[key];
}
